import * as types from './actionTypes';

export function receivePhotos(photos) {
	return { type: types.RECEIVE_PHOTOS, photos: photos };
}
